import React from 'react';
import {
  Document,
  Font,
  Page,
  StyleSheet,
  View,
} from '@react-pdf/renderer';
import signatureFont from '../../styles/fonts/signature/MonsieurLaDoulaise-Regular.ttf';
import OpenSansRegular from '../../styles/fonts/OpenSans/OpenSans-Regular.ttf';
import OpenSansBold from '../../styles/fonts/OpenSans/OpenSans-Bold.ttf';
import OpenSanSemiBold from '../../styles/fonts/OpenSans/OpenSans-SemiBold.ttf';
import OpenSansItalic from '../../styles/fonts/OpenSans/OpenSans-Italic.ttf';

import PdfDonorAgreement from './PdfDonorAgreement';
import PdfAuthorizationForDisclosure from './PdfAuthorizationForDisclosure';
import PdfAssignmentOfBenefit from './PdfAssignmentOfBenefit';

Font.register(
  {
    family: 'signature',
    format: 'truetype',
    src: signatureFont
  },
);
Font.register(
  {
    family: 'Opan Sans',
    format: 'truetype',
    src: OpenSansRegular,
    fontWeight: 400
  }
);
Font.register(
  {
    family: 'Opan Sans',
    format: 'truetype',
    src: OpenSanSemiBold,
    fontWeight: 500
  }
);
Font.register(
  {
    family: 'Opan Sans',
    format: 'truetype',
    src: OpenSansBold,
    fontWeight: 700
  }
);
Font.register(
  {
    family: 'Opan Sans Italic',
    format: 'truetype',
    src: OpenSansItalic,
    fontWeight: 400
  }
);

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#FFF',
    fontSize: 10,
    fontFamily: 'Opan Sans',
    color: '#5D5D5D'
  },
  pageBorder: {
    margin: 20,
    padding: 5,
    border: '2px solid #5D5D5D',
    flexGrow: 1
  },
  title: {
    margin: '0 auto',
    paddingTop: 10,
    fontSize: 10,
    fontWeight: 700
  },
  description: {
    fontSize: 9,
    padding: 10,
    lineHeight: 1.3
  },
  donorAgreementContentWrapper: {
    fontSize: 9,
    padding: 10,
    lineHeight: 1.3
  },
  agreeTermsBoxWrapper: {
    width: '70%',
    padding: 10,
    backgroundColor: '#add8e69e',
    margin: 10,
    position: 'absolute',
    bottom: 20,
    left: 10
  },
  checkboxImage: {
    width: 15,
    height: 15,
  },
  checkboxImagWithTextWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  textWrapper: {
    paddingLeft: 5
  },
  digitalSignatureBoxWrapper: {
    width: '100%',
    padding: 10,
    backgroundColor: '#fff',
    marginTop: 10,
  },
  listHeading: {
    fontWeight: 500
  },

  authWrapper: {
    marginTop: 5,
    marginBottom: 5
  },
  subHeading: {
    paddingLeft: 5
  }
});

// eslint-disable-next-line react/prop-types
const PdfAgreement = ({
  // eslint-disable-next-line react/prop-types
  name, insurer, signDate, signTime
}) => (
  <Document>

    <Page size="A4" style={styles.page} wrap>
      {/* eslint-disable-next-line react/no-children-prop */}
      <View style={styles.pageBorder} children={<PdfDonorAgreement name={name} signDate={signDate} signTime={signTime} />} />
    </Page>
    <Page size="A4" style={styles.page} wrap>
      {/* eslint-disable-next-line react/no-children-prop */}
      <View style={styles.pageBorder} children={<PdfAuthorizationForDisclosure name={name} signDate={signDate} signTime={signTime} />} />
    </Page>
    <Page size="A4" style={styles.page} wrap>
      {/* eslint-disable-next-line react/no-children-prop */}
      <View style={styles.pageBorder} children={<PdfAssignmentOfBenefit name={name} insurer={insurer} signDate={signDate} signTime={signTime} />} />

    </Page>
  </Document>
);
export default PdfAgreement;
